<template>
  <div class="weui-msg">
    <div class="weui-msg__icon-area">
      <i class="weui-icon_msg" :class="[success?'weui-icon-success':'weui-icon-warn']"></i>
    </div>
    <div class="weui-msg__text-area">
      <h2 class="weui-msg__title">{{ title }}</h2>
      <p class="weui-msg__desc" v-html="desc"></p>
    </div>
    <div class="weui-msg__opr-area">
      <slot></slot>
      <!--<p class="weui-btn-area">-->
      <!--<a href="javascript:history.back();" class="weui-btn weui-btn_primary">推荐操作</a>-->
      <!--<a href="javascript:history.back();" class="weui-btn weui-btn_default">辅助操作</a>-->
      <!--</p>-->
    </div>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-msg',
    props: {
      success: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: ''
      },
      desc: {
        type: String,
        default: ''
      }
    },
    data () {
      return {}
    },
    components: {},
    created () {
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {},
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?9d63edfe